export interface SelectItem {
  value: any;
  description: string;
}
